<div class="connection-success-dialog">
  <div class="success-icon">
    <mat-icon class="check-icon">check_circle</mat-icon>
  </div>

  <h2 class="modal-title">Connection created successfully</h2>

  <p class="modal-message">
    Would you like to test the connection <strong>{{ data.connectionName }}</strong> now?
  </p>

  <div class="modal-actions">
    <button mat-stroked-button class="skip-button" (click)="onSkip()">
      Skip
    </button>
    <button mat-raised-button class="start-testing-button" (click)="onStartTesting()">
      Start Testing
    </button>
  </div>
</div>
